import React, { Component } from 'react';
import '../../sass/_footer.scss';
import { Button, Navbar, Nav, NavDropdown, Container, FormControl, Form, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import Link from 'next/link';
export default class index extends Component {
    render() {
        return (
            <section>
                <Container>
                    <hr className="footer-divider mt-sm-0" />
                    <div className="">
                        <Row className="pt-3 pb-3">
                            <Col md className="mobile-footer-d">
                                <div className="footer-nav mt-4 mb-3 highlating-my-head">Company</div>
                                {/* <div className="footer-nav-link foot-cursour mt-3">About</div>
                                <div className="footer-nav-link foot-cursour">Careers</div> */}
                                <Link href="/contact-us" as="/contact-us">
                                    <div className="footer-nav-link foot-cursour">Contact Us</div>
                                </Link>
                                <video className="width-vedio" autoPlay loop muted playsInline>
                                    <source src={`${publicRuntimeConfig.staticFolder}/images/svg-vedio-software-dev.mp4`} type="video/mp4" />
                                </video>
                            </Col>
                            <Col md className="mobile-footer-d">
                                <div className="footer-nav mt-4 mb-3 highlating-my-head">Services</div>
                                <Link href="/analytics-services#Contextual-Dashboard" as="/analytics#Contextual-Dashboard">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour mt-3">Custom Software Development</div></a>
                                </Link>
                                <Link href="/ui-ux-design-services" as="/UX-UI-Design">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">UX / UI Design</div></a>
                                </Link>
                                <Link href="/branding-services#Brand-Identity" as="/Branding-and-Digital-Marketing#Brand-Identity">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Product Strategy</div></a>
                                </Link>
                                <Link href="/devalopment-services#Product-Engineering" as="/Software-Engineering#Product-Engineering">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Product Engineering Architecture</div></a>
                                </Link>
                                <Link href="/analytics-services" as="/analytics">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Data Analytics</div></a>
                                </Link>
                                <Link href="/analytics-services#Contextual-Dashboard" as="/analytics#Contextual-Dashboard">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Contextual Dashboards</div></a>
                                </Link>
                                <Link href="/devalopment-services#Mobile-App-Development" as="/Software-Engineering#Mobile-App-Development">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">App Development</div></a>
                                </Link>
                                <Link href="/devalopment-services#eCommerce" as="/Software-Engineering#eCommerce">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">eCommerce Application</div></a>
                                </Link>
                                <Link href="/devalopment-services#Mobile-App-Development" as="/Software-Engineering#Mobile-App-Development">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Web Development</div></a>
                                </Link>
                                <Link href="/branding-services" as="/Branding-and-Digital-Marketing">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Digital Marketing</div></a>
                                </Link>
                                <Link href="/branding-services#SEO" as="/Branding-and-Digital-Marketing#SEO">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">SEO</div></a>
                                </Link>
                            </Col>
                            <Col md className="mobile-footer-d">
                                <div className="footer-nav mt-4 mb-3 highlating-my-head">Platforms</div>
                                <Link href="/devalopment-services#Mobile-App-Development" as="/Software-Engineering#Mobile-App-Development">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour mt-3">iOS</div></a>
                                </Link>
                                <Link href="/devalopment-services#Mobile-App-Development" as="/Software-Engineering#Mobile-App-Development">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Android</div></a>
                                </Link>
                                <div className="footer-nav-link foot-cursour">Windows</div>
                                <Link href="/devalopment-services#Mobile-App-Development" as="/Software-Engineering#Mobile-App-Development">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Hybrid Platform</div></a>
                                </Link>
                                <div className="footer-nav-link foot-cursour">Azure</div>
                                <Link href="/devalopment-services" as="/Software-Engineering">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Magento</div></a>
                                </Link>
                                <Link href="/devalopment-services#eCommerce" as="/Software-Engineering#eCommerce">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">WooCommerce</div></a>
                                </Link>
                                <Link href="/devalopment-services#eCommerce" as="/Software-Engineering#eCommerce">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Shopify</div></a>
                                </Link>
                                <Link href="/analytics-services" as="/analytics">
                                    <a className="link-action"><div className="footer-nav-link foot-cursour">Tableau</div></a>
                                </Link>
                                <div className="footer-nav-link foot-cursour">Google Data Studio</div>
                                <div className="footer-nav-link foot-cursour">PowerBI</div>
                                <div className="footer-nav-link foot-cursour">OpenCV</div>
                                <div className="footer-nav-link foot-cursour">R</div>
                                <div className="footer-nav-link foot-cursour">Python</div>
                            </Col>
                            <Col className="mobile-footer-d">
                                <div className="fallow mt-4 mb-3">Follow Us On</div>
                                <div className="mt-3">
                                    <a href="https://www.linkedin.com/company/axlr-data/" target="_blank">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/linkedin.svg`} alt="linkedin-axlr-data" className="mr-4" />
                                    </a>
                                    <a href="https://www.facebook.com/axlrdata" target="_blank">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/awesome-facebook.svg`} alt="facebook-axlr-data" className="mr-4" />
                                    </a>
                                    {/* <img src={`${publicRuntimeConfig.staticFolder}/images/awesome-instagram.svg`} alt="instagram-axlr-data" /> */}
                                </div>
                                <Row>
                                    <Col md={11} xs={3}>
                                        <div className="footer-note mt-4 highlating-my-head">Phone:</div>
                                    </Col>
                                    <Col>
                                        <a href="tel: 996 643 6789" className="link-action">
                                            <div className="footer-note mt-2 mobile-fg">+91 996 643 6789</div>
                                        </a>
                                        <a href="tel: 970 052 3118" className="link-action">
                                            <div className="footer-note mt-2 mobile-fg">+91 970 052 3118</div>
                                        </a>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={11} xs={3}>
                                        <div className="footer-note mt-4 highlating-my-head">Email:</div>
                                    </Col>
                                    <Col>
                                        <div className="footer-note mt-2 mobile-fg">hello@axlrdata.com</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-nav-link foot-cursour text-center mb-4">© 2020. All Rights Reserved. Design by Axlrdata </div>
                </Container>
                <style jsx>
                    {`
                        .foot-cursour{
                            cursor:pointer;
                        }
                        .foot-cursour:hover{
                           color :#ff7400;
                        }
                        .highlating-my-head{
                            color: #ff7400 !important;
                        }
                        @media only screen and (max-width: 768px){
                            .main-heading{
                                font-size: 24px !important;
                                line-height: 40px !important;
                                letter-spacing: 4px !important;                            
                            }
                    }
                    `}
                </style>
            </section>
        )
    }
}
